import React, { memo } from 'react';
import _ from 'lodash';

import styles from './Sentence.module.scss';

type SentenceProps = {
  sentence: string;
  blanks: any[];
  submitted?: boolean;
  showYourAnswers?: boolean;
  showCorrectAnswer?: boolean;
  getValues?: Function;
  register?: Function;
  className?: string;
  preview?: boolean;
  style?: object;
  placeholder?: string;
  onClick?: React.MouseEventHandler<HTMLParagraphElement>;
};

function Sentence({
  sentence = '',
  blanks,
  submitted,
  showYourAnswers,
  showCorrectAnswer,
  getValues = () => {},
  register = () => {},
  className = '',
  preview,
  style,
  placeholder,
  onClick = () => {},
}: SentenceProps) {
  function Blank({ idx }: { idx: number }) {
    const id = blanks[idx]?.id;
    const expectedResponse = blanks[idx]?.text;
    const userAnswer = getValues(id) || '';

    if (preview)
      return <span className={styles.preview}>{expectedResponse}</span>;

    // warning: DO NOT use _.lowerCase (was crashing when using caps in mid string: ex: SuPeRHeRo)
    const filledCorrectly =
      submitted &&
      expectedResponse.toLowerCase().trim() === userAnswer.toLowerCase().trim();

    return (
      <span>
        <input
          id={id}
          type="text"
          autoComplete="off"
          placeholder={placeholder}
          {...register(id)}
          className={
            showYourAnswers && submitted
              ? filledCorrectly
                ? styles.correct
                : styles.incorrect
              : undefined
          }
          style={{ minWidth: `${expectedResponse.length * 10}px` }}
          disabled={submitted}
        />
        {submitted && showCorrectAnswer && !filledCorrectly && (
          <span className={styles.correctAnswer} data-testid="expectedResponse">
            ({expectedResponse})
          </span>
        )}
      </span>
    );
  }

  const wildcard = '[*]';

  let _sentence = sentence;
  _.forEach(blanks, (blank) => {
    _sentence = _.replace(_sentence, blank?.text, wildcard);
  });

  const startsWithBlank = _sentence.substr(0, wildcard.length) === wildcard;
  const endsWithBlank =
    _sentence.substr(_sentence.length - wildcard.length, wildcard.length) ===
    wildcard;

  const textBlocks = _.map(
    _.filter(_.split(_sentence, wildcard), (a) => !_.isEmpty(a)),
    (block) => block
  );

  const sentenceWithBlanks: any[] = [];
  startsWithBlank && sentenceWithBlanks.push(<Blank key={0} idx={0} />);

  _.forEach(textBlocks, (textBlock, i) => {
    const isLastTextBlock = i === textBlocks.length - 1;
    sentenceWithBlanks.push(textBlock);
    const key = startsWithBlank ? i + 1 : i;
    if (!isLastTextBlock || (isLastTextBlock && endsWithBlank))
      sentenceWithBlanks.push(<Blank key={key} idx={key} />);
  });

  return (
    <p
      className={[styles.Sentence, className].join(' ')}
      style={style}
      onClick={onClick}
    >
      {sentenceWithBlanks}
    </p>
  );
}

export default memo(Sentence);
